"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This is exported as a separate function so that we can mock it.
 * @alias isInDev
 * @internal
 */
exports.default = () => process.env.NODE_ENV === 'development';
